import { Controller } from "@hotwired/stimulus"
import FavoritesService from "../utilities/favorites_service"

// Shows "Saved to Favorites" if the product is in localStorage favorites.
export default class extends Controller {
  static values = { productId: Number }

  connect() {
    if (FavoritesService.isFavorited(this.productIdValue)) {
      this.element.style.display = ''
    }
  }
}
